import React from 'react'
import { CVP_ATTRIBUTES } from './strategyMapHelpers'
import './CanvasZonePlaceholders.css'

interface CvpAttributeStripProps {
  expressed: Set<string>
}

export const CvpAttributeStrip: React.FC<CvpAttributeStripProps> = ({ expressed }) => (
  <div className="canvas-kn-cvp-strip" aria-label="Customer Value Proposition attributes">
    {CVP_ATTRIBUTES.map(attr => (
      <span
        className={`canvas-kn-cvp-attr ${expressed.has(attr) ? 'is-expressed' : 'is-muted'}`}
        key={attr}
      >
        {attr}
      </span>
    ))}
  </div>
)
